import React, { Component } from 'react';
import './Deals.css';
import {DealItem} from './DealItem'
import SimpleSlider from '../SimpleSlider/SimpleSlider';
import { Img } from '../UI/UI';
import { getImgUrl , limitText } from "../../Utility/Utility"


class Deals extends Component {
  
  constructor (props){
  	super(props);
  	this.image_url = getImgUrl();
  	
  	this.dealsSliderSettings = {
      	dots: true,
      	infinite: true,
      	cssEase: 'linear',
      	autoplay:false,
      	lazyLoad: "ondemand",
      	slidesToShow: (this.props.items != undefined  ) ? this.props.items : 3,
		slidesToScroll: 1,
		responsive: [
	        {
	          breakpoint: 1000,
	          settings: {
	            slidesToShow: 2,
	            slidesToScroll: 2
	          }
	        },
	        {
	          breakpoint: 600,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }
      	]
    };

  	  	this.deals = [


			{
		        title: "Пакс",
		        agent: "paks",
		        desc: "Отдых на Красном море  (без авиаперелета)" ,
		        price: " 6 830 руб. " ,
		        logo: "/Deals/paks.png",
		        link: "https://newonline.paks.ru/search_hotel?STATEINC=729&TOURINC=507&CHECKIN_BEG=20200214&NIGHTS_FROM=3&CHECKIN_END=20200214&NIGHTS_TILL=3&ADULT=2&CURRENCY=1&CHILD=0&TOWNS=NaN%2C194&STARS_ANY=1&HOTELS_ANY=1&MEALS_ANY=1&PACKET=2&PRICEPAGE=1&DOLOAD=1",
		        ss_class: "ac-Deal-new-20199",
		        book_now: "Забронировать сейчас"
		      },
		      {
		        title: "Ural Airlines",
		        agent: "Ural_Airlines",
		        desc: "Москва (Жуковский) - Тель-Авив  от 7 305 руб",
		        price: "7 305 руб. ",
		        logo: "/Deals/21.jpg",
		        link: "https://www.uralairlines.com/en/aviabilety/moscow-zhykovsky-tel-aviv/?utm_source=referral.citiesbreak&utm_medium=cpc&utm_campaign=citiesbreak&utm_term=citiesbreak-banner",
		        css_class: "ac-Deal-new-7305",
		        book_now: "Забронировать сейчас"
		      },
		      {
		        title: "Aeroflot",
		        agent: "Aeroflot",
		        desc: "Большое разнообразие дешевых рейсов в Тель-Авив от 17 500 руб",
		        price: " 17 500 руб.",
		        logo: "/Deals/aeroflot.png",
		        link: "https://www.aeroflot.ru/sb/app/gb-ru?_preferredLocale=xx&_preferredLanguage=en#/search?adults=1&cabin=econom&children=0&infants=0&referrer=null&routes=MOW.20180814.TLV-TLV.20180817.MOW&_k=tso5cw",
		        css_class: "ac-Deal-17500",
		        book_now: "Забронировать сейчас"
		      },

		      {
		        title: "Пакс",
		        agent: "paks",
		        desc: "Отдых на Красном море  ( с авиаперелетом)" ,
		        price: " 20 199 руб. " ,
		        logo: "/Deals/paks.png",
		        link: "https://newonline.paks.ru/search_tour?TOWNFROMINC=3127&STATEINC=729&CHECKIN_BEG=20200214&NIGHTS_FROM=3&CHECKIN_END=20200214&NIGHTS_TILL=3&ADULT=2&CURRENCY=1&CHILD=0&TOWNS=NaN%2C194&STARS_ANY=1&HOTELS_ANY=1&MEALS_ANY=1&PRICEPAGE=1&DOLOAD=1",
		        ss_class: "ac-Deal-new-20199",
		        book_now: "Забронировать сейчас"
		      },
		      
		      {
		        title: "El Al",
		        agent: "El_Al",
		        desc: "Москва -Тель Авив- Москва  по выгодной цене",
		        price: " 20 760 руб. " ,
		        logo: "/Deals/elal.png",
		        link: "https://www.elal.com/Russia/Pages/default.aspx",
		        ss_class: "ac-Deal-new-20760",
		        book_now: "Забронировать сейчас"
		      },
		      {
		        title: "ICS",
		        agent: "ICS",
		        desc: "Туры в Тель-Авив и Иерусалим по выгодным ценам. Забронируйте сейчас!",
		        price: "25 896 руб.",
		        logo: "/Deals/12.jpg",
		        link: "https://www.icstrvl.ru/srch_v4/index.html#xd-s:city=538625;cnt=14472441;spo=0;cr=143104352+4173992539+4173720660+4174467815+4174475049+4174501519;transport=all_transports;ad=2;ch=0;infant=0;d=3+4;date=latest;cur=0;nonstop=1;gf=1;pg=1;ver=1455?utm_source=minisrael&utm_medium=citiesbreak&utm_campaign=email",
		        css_class: "ac-Deal-25896",
		        book_now: "Забронировать сейчас"
		      },

		      // {
		      //   title: "Пакс",
		      //   agent: "paks",
		      //   desc: "Отдых от 3-х ночей Тель-Авив/Иерусалим" ,
		      //   price: " 27 400 руб. " ,
		      //   logo: "/Deals/paks.png",
		      //   link: "https://newonline.paks.ru/search_tour?TOWNFROMINC=3127&STATEINC=729&CHECKIN_BEG=20191212&NIGHTS_FROM=3&CHECKIN_END=20191212&NIGHTS_TILL=3&ADULT=2&CURRENCY=1&CHILD=0&TOWNS=NaN%2C193%2CNaN%2C191&STARS_ANY=1&HOTELS_ANY=1&MEALS_ANY=1&PRICEPAGE=1&DOLOAD=1",
		      //   ss_class: "ac-Deal-new-27400",
		      //   book_now: "Забронировать сейчас"
		      // },

		      

		      {
		        title: "Русский Экспресс",
		        agent: "Русский Экспресс",
		        desc: "Weekend в Тель-Авиве (3 ночи)",
		        price: "28 800 руб.",
		        logo: "/Deals/Русский_Экспресс.jpg",
		        link: "https://book.r-express.ru:443/Extra/QuotedDynamic.aspx?departFrom=1&country=729&city=191&tour=782586&dateFrom=2019-10-31&dateTo=2019-11-07&nights=3&adults=2&childs=0&pageSize=20&aviaQuotaMask=5&hotelQuotaMask=5&mainOnly=0",
		        css_class: "ac-Deal-28800",
		        book_now: "Забронировать сейчас"
		      },

		      {
		        title: "Отели Тель-Авива",
		        agent: "Отели_Тель-Авива",
		        desc: "Откройте для себя Tel Aviv City Break Бесплатный ужин на двоих",
		        price: " 9 150 руб.",
		        logo: "/Deals/tlv-hotels.png",
		        link: "https://www.visit-tel-aviv.com/en/promotions/telaviv",
		        css_class: "ac-Deal-9150",
		        book_now: "Забронировать сейчас"
		      },

		      
		     
		      {
		        title: "Expedia",
		        agent: "Expedia",
		        desc: "Три ночи от 30,184 руб. на человека, при условии обратного рейса эконом-классом и при проживании двух гостей в одной комнате ",
		        price: "30 184 руб.",
		        logo: "/Deals/20.jpg",
		        link: "https://www.expedia.com/Hotel-Search?packageType=fh&searchProduct=hotel&c=500c9633-47c4-4316-98ff-a99da6b56f56&adults=1&destination=Tel+Aviv+(and+vicinity),+Israel&ttla=TLV&startDate=9/21/2017&endDate=9/24/2017&sort=recommended",
		        css_class: "ac-Deal-30184",
		        book_now: "Забронировать сейчас"
		      },
		       
		      // {
		      //   title: "VediTourGroup",
		      //   agent: "VediTourGroup",
		      //   desc: "City Break Тель-Авив, 3 ночи, вылет по четвергам, 02.05-28.11.19",
		      //   price: "31 676 руб.",
		      //   logo: "/Deals/24.jpg",
		      //   link: "https://advanced.veditour.ru:443/Extra/QuotedDynamic.aspx?departFrom=1&country=729&tour=117927&dateFrom=2019-11-28&dateTo=2019-11-28&adults=2&childs=0&pageSize=20&aviaQuotaMask=5&hotelQuotaMask=7&mainOnly=0",
		      //   css_class: "ac-Deal-new-31676",
		      //   book_now: "Забронировать сейчас"
		      // },
		      
		      // {
		      //   title: "VediTourGroup",
		      //   agent: "VediTourGroup",
		      //   desc: "City Break Иерусалим, 4 ночи, вылет по вс,  05.05-24.11.19",
		      //   price: "32 987 руб.",
		      //   logo: "/Deals/24.jpg",
		      //   link: "https://advanced.veditour.ru:443/Extra/QuotedDynamic.aspx?departFrom=1&country=729&tour=117926&dateFrom=2019-11-24&dateTo=2019-11-24&adults=2&childs=0&pageSize=20&aviaQuotaMask=5&hotelQuotaMask=7&mainOnly=0",
		      //   css_class: "ac-Deal-new-32987",
		      //   book_now: "Забронировать сейчас"
		      // },
		      {
		        title: "ANA",
		        agent: "Hosteling_International_Israel",
		        desc: "2 ночи с бесплатным завтраком в одном из наших отелей по всему Израилю, а также 3 билета в израильские парки и заповедники.",
		        price: "5 952  руб",
		        logo: "/Deals/19.jpg",
		        link: "http://www.iyha.org.il/wp-content/uploads/languages/citybreak.html ",
		        css_class: "ac-Deal-5952",
		        book_now: "Забронировать сейчас"
		      },
		      
		      // {
		      //   title: "VediTourGroup",
		      //   agent: "VediTourGroup",
		      //   desc: "City Break Тель-Авив+Иерусалим, 4 ночи, вылет ежедневно, 01.05-30.11.19",
		      //   price: "34 037 руб.",
		      //   logo: "/Deals/24.jpg",
		      //   link: "https://advanced.veditour.ru:443/Extra/QuotedDynamic.aspx?departFrom=1&country=729&tour=117928&dateFrom=2019-11-29&dateTo=2019-11-29&adults=2&childs=0&pageSize=20&aviaQuotaMask=5&hotelQuotaMask=7&mainOnly=0",
		      //   css_class: "ac-Deal-new-34037",
		      //   book_now: "Забронировать сейчас"
		      // },
		      {
		        title: "Аэротур",
		        agent: "Аэротур",
		        desc: "На недельку в Израиль. Ежедневно 7 ночей + 2 экскурсии",
		        price: "44 306 руб.",
		        logo: "/Deals/aerotur.jpg",
		        link: "https://online.aerotur.travel/TourSearchClient/?departureCities=1&destination=1_729&destCities=-1&tourType=-1&dates=20.02.2020,19.03.2020,23.04.2020,21.05.2020,18.06.2020,16.07.2020,20.08.2020&durations=8&adultCount=2&hotelQuota=5&aviaQuota=5&busTransferQuota=7&currency=RUB&tours=100006639",
		        css_class: "ac-Deal-41551",
		        book_now: "Забронировать сейчас"
		      },
		      
		      {
		        title: "KMP",
		        agent: "KMP",
		        desc: "Исторический тур с отдыхом на Мёртвом море",
		        price: "58 552 руб.",
		        logo: "/Deals/7.jpg",
		        link: "http://kmp.ru/countries/il/tour/200013872/?utm_source=cb&utm_medium=tgb&utm_campaign=israel",
		        css_class: "ac-Deal-58552",
		        book_now: "Забронировать сейчас"
		      },
		      {
		        title: "Premiera",
		        agent: "Premiera",
		        desc: "Святой Иерусалим (Иерусалим 2ночи + Тель-Авив 5 ночей)",
		        price: "61 000 руб.",
		        logo: "/Deals/premiera.jpg",
		        link: "http://premiera.travel/tury-za-granicu/tour/svyatoy-ierusalim",
		        css_class: "ac-Deal-61000",
		        book_now: "Забронировать сейчас"
		      },
		      {
		        title: "VediTourGroup",
		        agent: "VediTourGroup",
		        desc: "City Breack Тель-Авив, 3 ночи с перелетом из Москвы. Дополнительно можно заказать трансферы и экскурсии",
		        price: "65 233 руб.",
		        logo: "/Deals/24.jpg",
		        link: "https://advanced.veditour.ru/Extra/QuotedDynamic.aspx?departFrom=1&country=729&tour=130258&dateFrom=2020-03-05&dateTo=2020-03-08&adults=2&childs=0&pageSize=20&aviaQuotaMask=5&hotelQuotaMask=7&mainOnly=0",
		        css_class: "ac-Deal-new-65233",
		        book_now: "Забронировать сейчас"
		      },
		      {
		        title: "KMP",
		        agent: "KMP",
		        desc: "Настоящее путешествие по Израилю. Тель-Авив  - Эйлат - Мёртвое море.",
		        price: "72 056 руб.",
		        logo: "/Deals/7.jpg",
		        link: "http://kmp.ru/countries/il/tour/200018823/?utm_source=cb&utm_medium=tgb&utm_campaign=israel",
		        css_class: "ac-Deal-72056",
		        book_now: "Забронировать сейчас"
		      },
		      {
		        title: "KMP",
		        agent: "KMP",
		        desc: "Гранд тур в Израиль.Тель-Авив, Иерусалим и Эйлат. Заезды ежедневно. Отели 3-5*",
		        price: "78 932 руб.",
		        logo: "/Deals/7.jpg",
		        link: "https://eur01.safelinks.protection.outlook.com/?url=http%3A%2F%2Fkmp.ru%2Fcountries%2Fil%2Ftour%2F200014104%2F%3Futm_source%3Dcb%26utm_medium%3Dtgb%26utm_campaign%3Disrael&data=02%7C01%7Cmarketing-ru%40goisrael.gov.il%7C35f4c0f020304b96369708d6f3275ac2%7Ce5a1a45ba59f44db8fa1d979ba86371b%7C1%7C0%7C636963747699239305&sdata=PYieDjAcZu1MuOBz8BT789dTVnE034kxN2prvqCdts8%3D&reserved=0",
		        css_class: "ac-Deal-78932",
		        book_now: "Забронировать сейчас"
		      }

	

  	]

  }

  render() {

  	const dealsHtml = this.deals.map((o)=>{
  		return <DealItem
		            key={ o.title }  
  					brand={ o.title } 
  					price={ o.price } 
  					brandImg={ o.logo } 
  					desc={ o.desc } 
  					bookNowLink={o.link}
  					descFontSize={ o.fontSize }
				/>
  	})
    return (
	      <div className="deals-wrapper">
        	<SimpleSlider settings={this.dealsSliderSettings}>
	           {dealsHtml}
          	</SimpleSlider>
	      </div>
    );
  }
}

export default Deals;



// WEBPACK FOOTER //
// ./src/Components/Deals/Deals.js